// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"8b9f9cbb","421":"6a12d5d5","583":"2567dbc2","601":"3d9aefb9","808":"e407a1b7","891":"6f186468","918":"45204dbb","978":"90fc08d7"}[chunkId] + ".chunk.js";
};